
import VButton from '~/components/ui/VButton';
import { mapState, mapGetters, mapActions } from 'vuex';
import FormattedImage from '~/components/common/FormattedImage';
import ProjectTimer from '~/components/project/ProjectTimer';
import { APPLICATION_STATUSES } from '~/const';
import moment from 'moment';

export default {
    name: 'ProjectCard',
    components: {
        VButton,
        FormattedImage,
        ProjectTimer,
    },
    props: {
        viewRouteName: {
            type: String,
            default: ''
        },
        item: {
            type: Object,
            required: true
        },
        hasButton: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            authDialogIsVisible: false,
            loadingFavorite: false
        }
    },
    computed: {
        ...mapState('profile', [
            'currentAccount',
            'isAuthorized',
            'profiles'
        ]),
        ...mapGetters('profile', [
            'role',
        ]),
        description() {
            if ( this.item.description.length > 180) {
                return `${this.item.description.substring(0, 180)}...`
            }
            return this.item.description
        },
        isMyInvestition(){
            return this.item.invest && this.item.invest.is_my_invest;
        },
        financeRoundStartDate() {
            return `${moment(this.item.finance_round.start_date).format("DD.MM.YYYY")} в ${moment(this.item.finance_round.start_date).format("HH:mm")}`
        },
        financeRoundEndDate() {
            return `${moment(this.item.finance_round.money_collect_date).format("DD.MM.YYYY")} в ${moment(this.item.finance_round.money_collect_date).format("HH:mm")}`
        },
        accessSumInfo() {
            if (this.isAuthorized) {
                if (this.item.status === 'finance_round') {
                    if (this.role === 'borrower') {
                        if (this.isOwner) {
                            return true
                        } else {
                            return false
                        }
                    } else if (this.role === 'investor') {
                        return true
                        // if (this.currentAccount && this.currentAccount.declaration_signed) {
                        //     return true
                        // } else {
                        //     return false
                        // }
                    } else {
                        return false
                    }
                }
                return true
            }
            return false
        },
        isOwner() {
            return this.item.is_my
        },
        eightyPercent() {
            return this.item.finance_round.sum * 0.8;
        },
        canExtendRound(){
            return this.item.status === 'finance_round_time' && !this.item.is_extended && (this.eightyPercent > this.item.current_sum)
        },
        progressColor() {
            if ((this.item.status === 'finance_round_time' || this.item.status === 'loan_agreement' || this.item.status === 'fulfilled') && this.progress === 100) {
                return 'green'
            }
            return 'blue'
        },
        roundEndDate() {
            return new Date(this.item.finance_round.end_date).toLocaleDateString('ru-RU')
        },
        roundEndTime() {
            return new Date(this.item.finance_round.end_date).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })
        },
        progress() {
            const sum = this.item.finance_round ? this.item.finance_round.sum : 0
            if (this.item.current_sum) {
                return Math.floor(
                    this.item.current_sum / (parseInt(sum, 10) / 100)
                );
            }
            return 0;
        },
        interestRate() {
            if (this.item.interest_rate_from === this.item.interest_rate_to) {
                return this.item.interest_rate_from + '%'
            }
            return `${this.item.interest_rate_from} - ${this.item.interest_rate_to}%`
        },
        currentStatus() {
            return APPLICATION_STATUSES.find(el => el.id === this.item.status)
        },
        currentStatusName() {
            if (this.currentStatus) {
                if (this.currentStatus.id === 'approved' && this.item.is_view) {
                    return 'Ожидание начала раунда'
                }
                return this.currentStatus.name
            }
            return ''
        },
        currentStatusColor() {
            if (this.currentStatus) {
                return this.currentStatus.color
            }
            return ''
        },
        investorState() {
            if (this.role === 'investor') {
                return {
                    declaration_signed: this.currentAccount && this.currentAccount.declaration_signed,
                    canViewCard: this.isAuthorized && this.currentAccount && this.currentAccount.declaration_signed
                }
            }
            return null;
        },
        buttonData() {
            switch (this.item.status) {
                case 'edit':
                    return {
                        text: 'Заполнить',
                        fn: () => {
                            this.$router.push({
                                name: 'ApplicationCardDetail',
                                params: {
                                    id: this.item.id
                                }
                            })
                        }
                    }
                case 'approved':
                    return {
                        text: 'Открыть раунд',
                        fn: () => {
                            this.$router.push({
                                name: 'ApplicationCardDetail',
                                params: {
                                    id: this.item.id
                                }
                            })
                        }
                    }
                case 'canceled':
                    return {
                        text: 'Редактировать',
                        fn: () => {
                            this.$router.push({
                                name: 'ApplicationCardDetail',
                                params: {
                                    id: this.item.id
                                }
                            })
                        }
                    }
                default:
                    return {
                        text: 'Подробнее',
                        fn: () => {
                            this.$router.push({
                                name: 'CardDetail',
                                query: {
                                    card: this.item.id
                                }
                            })
                        }
                    }
            }
        }
    },
    methods: {
        goToFundSupport() {
            window.open('https://cofi.ru/blog/itogi-goda-v-kreativnyx-industriiax-desiatki-predprinimatelei-polucili-masstabnuiu-finansovuiu-podderzku', '_self')
        },
        removeProject() {
            this.$modal.show('default-modal', {
                title: `Удаление зявки`,
                description: 'Вы уверены что хотите удалить заявку на займ?',
                maxWidth: 620,
                content: {
                    component: () => import('~/components/common/DialogModalContent.vue'),
                    props: {
                        buttons: [{
                            title: 'Отменить',
                            outlined: true,
                            dark: true,
                            width: '200px',
                            handler: () => {
                                this.$modal.hide('default-modal')
                            }
                        },{
                            title: 'Удалить',
                            width: '200px',
                            handler: () => {
                                this.$axios.delete(`short-application/${this.item.id}`).then(() => {
                                    this.$notify({
                                        type: 'success',
                                        title: 'Заявка успешно удалена!',
                                    })
                                    this.$emit('deleteItem')
                                    this.$modal.hide('default-modal')
                                }).catch(() => {
                                    this.$modal.hide('default-modal')
                                    this.$notify({
                                        type: 'error',
                                        title: 'Возникла ошибка при удалении заявки, обратитесь в поддержку',
                                    })
                                })
                            }
                        }],
                    }
                }
            })
        },
        showAuthDialog() {
            this.authDialogIsVisible = true
        },
        hideAuthDialog() {
            this.authDialogIsVisible = false
        },
        like() {
            if (this.role === 'investor' && !this.loadingFavorite) {
                this.loadingFavorite = true;
                this.item.is_favorite = true
                this.setToFavourite(this.item.id)
                    .then(data => {
                        this.item.favorite_count = data.item.count
                        this.$notify({
                            title: 'Заявка добавлена в Избранное',
                            type: 'success',
                        })
                    })
                    .finally(() => {
                        this.loadingFavorite = false;
                    });
            }
        },
        dislike() {
            if (this.role === 'investor' && !this.loadingFavorite) {
                this.loadingFavorite = true;
                this.item.is_favorite = false
                this.removeFromFavourite(this.item.id)
                    .then(data => {
                        this.item.favorite_count = data.item.count
                        this.$notify({
                            title: 'Заявка удалена из Избранного',
                            type: 'warn',
                        })
                    })
                    .finally(() => {
                        this.loadingFavorite = false;
                    });
            }
        },
        likeToggle() {
            if (this.item.is_favorite) {
                this.dislike()
            } else {
                this.like()
            }
        },
        investModal() {
            if(this.item){
                this.$modal.show('project-invest',
                    {
                        application: this.item,
                        callback: this.showInvestConfirmModal
                    }
                )
            }
        },
        showInvestConfirmModal() {
            this.$modal.show('project-invest-confirm', {
                application: this.item,
                callback: this.updateDataApplication
            });
        },
        async updateDataApplication() {
            // const responseApp = await this.$axios.get(`/application/${this.$route.params.slug}`);
            // let responseBalance = null
            // if (this.role === 'investor' && responseApp.data.item.invest && responseApp.data.item.invest.is_my_invest) {
            //     responseBalance = await this.$axios.get(`/invest/${responseApp.data.item.invest.id}/balance`)
            // } else {
            //     responseBalance = null
            // }

            // this.application = responseApp?.data?.item || null;
            // this.isAvailableCancelDeal = responseBalance ? responseBalance?.data?.item?.can_cancel : false;
            // alert('ИНВЕСТИРОВАНО!!!')
            window.location.reload();
        },
        handleItemClick(item) {
            if (this.viewRouteName && !item.is_short) {
                if (this.viewRouteName === 'profile-order-detail-index-id-schedule') {
                    if (this.role === 'investor') {
                        switch (item.status) {
                            case 'finance_round_time':
                            case 'finance_round':
                                return this.$router.push({
                                    name: 'project-slug',
                                    params: {
                                        slug: item.slug
                                    }
                                })
                            case 'fulfilled':
                            case 'concluded':
                            case 'loan_agreement':
                                return this.$router.push({
                                    name: this.viewRouteName,
                                    params: {
                                        id: item.invest.loan_id
                                    }
                                })
                            default:
                                return true
                        }
                    } else {
                        switch (item.status) {
                            case 'fulfilled':
                            case 'loan_agreement':
                                return this.$router.push({
                                    name: this.viewRouteName,
                                    params: {
                                        id: item.loan_id
                                    }
                                })
                            case 'edit':
                                return window.open(`/profile/application/${item.id}/edit`, '_self');
                            default:
                                return this.$router.push({
                                    name: 'project-slug',
                                    params: {
                                        slug: item.slug
                                    }
                                })
                        }
                    }
                }
            } else {
                if (item.is_short) {
                    this.$modal.show('default-modal', {
                        title: `Заявка`,
                        maxWidth: 620,
                        content: {
                            component: () => import('~/components/project/ProjectShortModal.vue'),
                            props: {
                                project: item
                            }
                        }
                    })
                } else {
                    if (this.isAuthorized) {
                        // if (item.status === 'finance_round') {
                        //     if (this.role === 'investor') {
                        //         if (!this.currentAccount && this.profiles.length < 1) {
                        //             this.$modal.show('default-modal', {
                        //                 title: `Внимание!`,
                        //                 maxWidth: 620,
                        //                 content: {
                        //                     component: () => import('~/components/common/DialogModalContent.vue'),
                        //                     props: {
                        //                         description: 'Для инвестирования в заявку, завершите регистрацию на платформе.',
                        //                         buttons: [{
                        //                             title: 'Продолжить',
                        //                             handler: () => {
                        //                                 window.open(`/register-type`, '_self')
                        //                             }
                        //                         }],
                        //                     }
                        //                 }
                        //             })
                        //             return true
                        //         } else if (!this.currentAccount && this.profiles.length > 0 && (this.profiles[0].status === 'checked' || this.profiles[0].status === 'set_status')) {
                        //             this.$modal.show('default-modal', {
                        //                 title: `Внимание!`,
                        //                 maxWidth: 620,
                        //                 content: {
                        //                     component: () => import('~/components/common/DialogModalContent.vue'),
                        //                     props: {
                        //                         description: 'Инвестирование в заявку будет доступно после проверки ваших регистрационных данных.',
                        //                         buttons: [{
                        //                             title: 'Ок',
                        //                             handler: () => {
                        //                                 this.$modal.hide('default-modal')
                        //                             }
                        //                         }],
                        //                     }
                        //                 }
                        //             })
                        //             return true
                        //         } else if (this.currentAccount && !this.currentAccount.declaration_signed) {
                        //             this.$modal.show('default-modal', {
                        //                 title: `Внимание!`,
                        //                 maxWidth: 620,
                        //                 content: {
                        //                     component: () => import('~/components/common/DialogModalContent.vue'),
                        //                     props: {
                        //                         description: 'Для инвестирования в заявку, подпишите декларацию соответствия.',
                        //                         buttons: [{
                        //                             title: 'Подписать',
                        //                             handler: () => {
                        //                                 this.$modal.hide('default-modal')
                        //                                 setTimeout(() => {
                        //                                     this.$modal.show('default-modal', {
                        //                                         title: `Данные подтверждены`,
                        //                                         maxWidth: 620,
                        //                                         content: {
                        //                                             component: () => import('~/components/common/Declaration.vue')
                        //                                         }
                        //                                     })
                        //                                 }, 500)
                        //                             }
                        //                         }],
                        //                     }
                        //                 }
                        //             })
                        //             return true
                        //         }
                        //     }
                        // }
                        // if (item.status === 'finance_round' || item.status === 'finance_round_time') {
                        //     if (this.role === 'borrower' && !this.isOwner) {
                        //         return true;
                        //     }
                        // }
                        if (this.role === 'borrower') {
                            if (this.isOwner && (item.status === 'finance_round' || item.status === 'approved')) {
                                return this.$router.push({
                                    name: 'project-slug',
                                    params: {
                                        slug: item.slug
                                    }
                                })
                            }
                        }
                        if (this.role === 'investor') {
                            if (item.status === 'finance_round' || item.status === 'approved') {
                                return this.$router.push({
                                    name: 'project-slug',
                                    params: {
                                        slug: item.slug
                                    }
                                })
                            }
                        }
                        return true
                    }
                    return true
                    // return this.$router.push({ name: 'project-slug', params: { slug: item.slug } });
                }
            }
        },
        ...mapActions('favorite', [
            'setToFavourite',
            'removeFromFavourite'
        ]),
    }
}
